import BaseModel from "../../core/components/input-widget/BaseModel";
import moment from "moment";
import {SYSTEM_DATE_FORMAT} from "@/core/services/formatter.service";

export default class TransferNoteSearchModel extends BaseModel {
  service_provider = null;
  type = null;
  status = null;
  origin_item_location_uuid = null;
  destination_item_location_uuid = null;
  title = null;
  rep_user_uuid = null;
  issue_date = null;
  issue_date_date_range = {};
  arrival_date = null;
  receipt_no = null;
  item_no = null;
  arrival_date_date_range = {};

  rules = {};

  attributeLabels = {
  };

  attributePlaceholders = this.attributeLabels;

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }

  toJSON() {
    let data = super.toJSON();

    if (data.issue_date_date_range && data.issue_date_date_range.startDate && data.issue_date_date_range.endDate) {
      data.issue_date_after = moment(data.issue_date_date_range.startDate).format(SYSTEM_DATE_FORMAT);
      data.issue_date_before = moment(data.issue_date_date_range.endDate).format(SYSTEM_DATE_FORMAT);
    }
    if (data.arrival_date_date_range && data.arrival_date_date_range.startDate && data.arrival_date_date_range.endDate) {
      data.arrival_date_after = moment(data.arrival_date_date_range.startDate).format(SYSTEM_DATE_FORMAT);
      data.arrival_date_before = moment(data.arrival_date_date_range.endDate).format(SYSTEM_DATE_FORMAT);
    }

    delete data.rep_user
    delete data.origin_item_location
    delete data.destination_item_location
    delete data.issue_date_date_range
    delete data.issue_date
    delete data.arrival_date_date_range
    delete data.arrival_date

    if (data.receipt_no && data.item_no) {
      data.stock_no = `${data.receipt_no}/${data.item_no}`
      delete data.receipt_no
      delete data.item_no
    }

    return data;
  }

}
